var map = {
	"./BBC.jpg": 36,
	"./BBC.png": 2402,
	"./BHH.jpg": 8603,
	"./BHH.png": 475,
	"./DTR.jpg": 1415,
	"./DTR.png": 2363,
	"./HRB.jpg": 2742,
	"./HRB.png": 6903,
	"./HUN.jpg": 8576,
	"./HUN.png": 4819,
	"./ING.jpg": 7249,
	"./ING.png": 9475,
	"./KOEL.jpg": 5444,
	"./KOEL.png": 698,
	"./LDK.jpg": 9783,
	"./LDK.png": 6129,
	"./RRR.jpg": 2932,
	"./RRR.png": 1937,
	"./THB.jpg": 6977,
	"./THB.png": 2829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7520;